import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import type { LitsPresence } from "./Player";
import { registerLitsTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type { LitsDefinition, LitsProgress, LitsSolution, LitsSubmission } from "./types";

registerLitsTranslations(i18n);

export const litsModule: PuzzleTypeModule<
  LitsDefinition,
  LitsSubmission,
  LitsProgress,
  LitsSolution,
  LitsPresence
> = {
  key: "lits",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
